module.exports = __webpack_public_path__ + "static/media/orquestra_salao_3.8523cc37.jpg";